import { sharedStyles } from "./sharedStyles";
const applyStyles = sharedStyles(`
      :host {
        display: inline;
      }

      .spoiler-content {
        filter: blur(6px);
        cursor: pointer;
        user-select: none;
        transition: filter 0.3s ease;
        display: inline;
      }

      .spoiler-content.revealed {
        filter: none;
        cursor: default;
        user-select: text;
      }
    `);
class SpoilerSpan extends HTMLElement {
    isRevealed = false;
    rendered = false;
    contentWrapper;
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.contentWrapper = document.createElement("span");
    }
    connectedCallback() {
        // Virtual-list recycling re-connects the same element; render once.
        if (this.rendered)
            return;
        this.rendered = true;
        this.render();
        this.setupEventListeners();
    }
    render() {
        this.contentWrapper.className = "spoiler-content";
        this.contentWrapper.innerHTML = this.innerHTML;
        applyStyles(this.shadowRoot);
        this.shadowRoot.appendChild(this.contentWrapper);
    }
    setupEventListeners() {
        this.contentWrapper.addEventListener("click", () => {
            if (!this.isRevealed) {
                this.reveal();
            }
        });
    }
    reveal() {
        this.isRevealed = true;
        this.contentWrapper.classList.add("revealed");
        this.dispatchEvent(new CustomEvent("spoiler-revealed", {
            bubbles: true,
            composed: true,
        }));
    }
    revealSpoiler() {
        this.reveal();
    }
    get revealed() {
        return this.isRevealed;
    }
}
customElements.define("spoiler-span", SpoilerSpan);
